import React from "react";
import ProfileBanner from "../components/ProfileBanner";
import ProfileInfo from "../components/ProfileInfo";
import ProfileTab from "../components/ProfileTab";
import ProfileHeaderSlider from "../components/Header-Slider/ProfileHeaderSlider";
import Footer from "./Footer/Footer";
import { useSelector } from "react-redux";
import HeaderSlider from "./Header-Slider/HeaderSlider";
import HeaderMainNavigation from "../layout/HeaderMainNavigation";

const ProductList = () => {
  const currTab = useSelector((state) => state.controlTab?.tab);
  return (
    <React.Fragment>
      <ProfileHeaderSlider />
      <HeaderSlider />
      <HeaderMainNavigation />
      <>
      {currTab !== 2?
        <React.Fragment>
          <ProfileBanner />
          <ProfileInfo />
        </React.Fragment>
    :null}
      </>

      <div className="position-relative collection-banner-slider">
        <ProfileTab />
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default ProductList;
